import { SharedState } from 'app/types-shared';

export const getTextConfigurationAccess =
  (sharedState: SharedState): boolean =>
    sharedState?.access?.adminPanel?.translation?.administrationCentral || false;
